<template>
    <b-card>
    <b-card-header>Att göra</b-card-header>
    <b-card-body>
        <b-row>
            <b-col>
            <b-button @click="NewTodo()">+ Ny aktivitet</b-button>
            </b-col>
        </b-row>
        <queryview
          qvtype="TodoTask" 
          ref="grid"     
          :selectable="true"
          v-on:rowclicked="onclick"
          v-bind:currentkey="currId"          
          v-on:currentkeychanged="oncurrentkeychanged"          
        ></queryview>
        <b-modal v-model="editVisible" size="xl" ok-only @ok="editOk" v-on:close="editOk" :no-close-on-backdrop="true" v-bind:no-close-on-esc="true">
          <todoedit ref="editor" v-bind:id="currId"></todoedit>
        </b-modal>
        
    </b-card-body>
    </b-card>
</template>
<script>
    import queryview from "./../queryview/queryview";
    import todoedit from "./todoedit.vue"

    export default {
        name: 'todolist',
        components: { queryview, todoedit },
        data() {
            return {
                currId:null,
                editVisible: false,
            }
        },
        methods: {
          NewTodo() {
            if(!this.editVisible) {
              this.currId = 0;
              this.editVisible=true;
            }
          },
          onclick(row) {
            this.currId = row._key;
            this.editVisible = true;
          },
          step(s) {
            this.$refs.grid.StepCurrent(s);
          },
          oncurrentkeychanged(row) {
            this.onclick(row);
          },
          editOk(ev) {
            if(this.$refs.editor.IsChanged()) {
              if(!confirm("Vill du verkligen stänga utan att spara?"))
                ev.preventDefault();
            }
            this.$refs.grid.GetData();
         },         
        },
        

    }
</script>